import { FC } from "react";

const PrivacyPolicy: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">Политика конфиденциальности</h2>
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="prose max-w-none">
          <p className="font-semibold mb-4">
            Политика конфиденциальности сайта «КЦ Авто»
          </p>
          <p className="mb-4">
            Настоящая Политика конфиденциальности описывает, как Индивидуальный
            предприниматель Боровиков Григорий Владимирович (далее – ИП Боровиков
            Г.В., Оператор) собирает, использует и защищает персональные данные
            пользователей сайта «КЦ Авто» (kcsib.ru) (далее – Сайт).
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">1. Общие положения</h3>
          <p className="mb-2">
            1.1. Настоящая Политика конфиденциальности разработана в соответствии
            с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О
            персональных данных».
          </p>
          <p className="mb-4">
            1.2. Используя Сайт, вы соглашаетесь с условиями настоящей Политики
            конфиденциальности.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            2. Информация об Операторе персональных данных
          </h3>
          <p className="mb-2">
            2.1. Оператором персональных данных является Индивидуальный
            предприниматель Боровиков Григорий Владимирович.
          </p>
          <p className="mb-2">2.2. ИНН: 420524372176</p>
          <p className="mb-4">2.3. ОГРНИП: 310420518800049</p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            3. Цели обработки персональных данных
          </h3>
          <p className="mb-2">
            3.1. Оператор обрабатывает персональные данные пользователей Сайта в
            следующих целях:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>
              Обработка и выполнение заявок на предварительный резерв
              автозапчастей.
            </li>
            <li>
              Связь с пользователями для уточнения деталей резерва и
              предоставления информации о статусе заказа.
            </li>
            <li>Улучшение функциональности и удобства использования Сайта.</li>
            <li>Ведение истории заказов (резервов) пользователей.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            4. Виды собираемых персональных данных
          </h3>
          <p className="mb-2">
            4.1. Оператор собирает следующие категории персональных данных
            пользователей:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Имя.</li>
            <li>Номер телефона.</li>
            <li>Адрес электронной почты.</li>
            <li>IP-адрес.</li>
            <li>История заказов (предварительных резервов).</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            5. Правовые основания обработки персональных данных
          </h3>
          <p className="mb-4">
            5.1. Обработка персональных данных осуществляется на основании
            согласия пользователя, которое предоставляется при регистрации или
            оформлении заказа.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            6. Передача персональных данных третьим лицам
          </h3>
          <p className="mb-2">
            6.1. Оператор может передавать персональные данные пользователей
            следующим третьим лицам:
          </p>
          <ul className="list-disc pl-6 mb-2">
            <li>
              Сервисам веб-аналитики для анализа посещаемости и поведения
              пользователей на Сайте с целью улучшения его работы.
            </li>
          </ul>
          <p className="mb-4">
            6.2. Оператор обязуется не передавать персональные данные
            пользователей иным третьим лицам без предварительного согласия
            пользователя, за исключением случаев, предусмотренных
            законодательством Российской Федерации.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            7. Хранение и защита персональных данных
          </h3>
          <p className="mb-2">
            7.1. Оператор хранит персональные данные пользователей в течение
            всего периода функционирования Сайта или до момента отзыва согласия
            пользователем. Оператор может хранить некоторые персональные данные и
            после удаления аккаунта пользователя в случае необходимости
            соблюдения требований законодательства.
          </p>
          <p className="mb-2">
            7.2. Оператор принимает необходимые правовые, организационные и
            технические меры для защиты персональных данных пользователей от
            неправомерного или случайного доступа, уничтожения, изменения,
            блокирования, копирования, распространения, а также от иных
            неправомерных действий. К таким мерам могут относиться, в частности:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Использование защищенных протоколов передачи данных.</li>
            <li>
              Ограничение доступа к персональным данным для определенных
              сотрудников.
            </li>
            <li>Регулярное обновление программного обеспечения.</li>
            <li>Иные меры.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            8. Права субъектов персональных данных
          </h3>
          <p className="mb-2">8.1. Пользователи Сайта имеют право:</p>
          <ul className="list-disc pl-6 mb-2">
            <li>
              Получать информацию, касающуюся обработки их персональных данных
              Оператором.
            </li>
            <li>
              Требовать от Оператора уточнения, блокирования или уничтожения их
              персональных данных в случае, если они являются неполными,
              устаревшими, неточными, незаконно полученными или не являются
              необходимыми для заявленной цели обработки.
            </li>
            <li>Отозвать свое согласие на обработку персональных данных.</li>
            <li>
              Реализовывать иные права, предусмотренные законодательством
              Российской Федерации в области персональных данных.
            </li>
          </ul>
          <p className="mb-4">
            8.2. Для реализации своих прав пользователь может обратиться к
            Оператору по контактному телефону: +7 (3842) 76-30-76.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            9. Использование файлов cookie
          </h3>
          <p className="mb-2">
            9.1. Сайт использует файлы cookie для сбора информации об
            использовании Сайта пользователями, улучшения его функциональности и
            проведения аналитических исследований. В частности, используются
            cookie сервиса Яндекс Метрика.
          </p>
          <p className="mb-4">
            9.2. Пользователь может управлять настройками файлов cookie в своем
            браузере. Отключение файлов cookie может повлиять на корректную
            работу некоторых функций Сайта.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">
            10. Заключительные положения
          </h3>
          <p className="mb-2">
            10.1. Оператор оставляет за собой право вносить изменения в настоящую
            Политику конфиденциальности в любое время без предварительного
            уведомления пользователей. Новая редакция Политики конфиденциальности
            вступает в силу с момента ее размещения на Сайте.
          </p>
          <p className="mb-4">
            10.2. По вопросам, не урегулированным настоящей Политикой
            конфиденциальности, стороны руководствуются действующим
            законодательством Российской Федерации.
          </p>

          <p className="text-gray-600 text-sm mt-4">
            Дата публикации: 02 июня 2025 г.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;